import { z } from "zod";

/** ສະກຸນທີ່ຮ້ານ / POS / ຄາຕາລັອກໃຊ້ຮ່ວມກັນ (ສອດຄ່ອງ DB) */
export const SHOP_CURRENCIES = ["LAK", "THB", "USD"] as const;
export type ShopCurrency = (typeof SHOP_CURRENCIES)[number];

export const DEFAULT_SHOP_CURRENCY: ShopCurrency = "LAK";

export const ShopCurrencySchema = z.enum(SHOP_CURRENCIES);

export function isShopCurrency(v: string): v is ShopCurrency {
  return (SHOP_CURRENCIES as readonly string[]).includes(v);
}

const LAK_FRACTION = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
} as const;

const THB_USD_FRACTION = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
} as const;

/**
 * ສະແດງຍອດເງິນຕາມສະກຸນ — LAK ບໍ່ສະແດງທົດສະນິຍົມ (ສະເພາະການສະແດງ; ຄ່າໃນ DB ອາດເປັນທົດສະນິຍົມໄດ້)
 */
export function formatShopMoney(
  amount: number,
  currency: string,
  locale = "lo-LA",
): string {
  const code = isShopCurrency(currency) ? currency : DEFAULT_SHOP_CURRENCY;
  const digits = code === "LAK" ? LAK_FRACTION : THB_USD_FRACTION;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      ...digits,
    }).format(amount);
  } catch {
    return `${amount} ${code}`;
  }
}

/** ຊື່ເກົ່າທີ່ໃຊ້ໃນ POS — ຄືກັນກັບ formatShopMoney */
export const formatPrice = formatShopMoney;

/** ຊື່ສຳລັບໃບເສັດ / ພິມ — ຄືກັນກັບ formatShopMoney */
export const formatMoney = formatShopMoney;
